module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('account-permissions-table'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshAccountPermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6290527d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountPermissions.vue
// module id = 538
// module chunks = 0